;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React, { useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import cx from 'clsx';

import Img from 'components/ui/Img';
import Text from 'components/ui/Text';

import useDetectTouch from 'hooks/useDetectTouch';

import styles from './TalesBlockTwoImageCycle.module.scss';

const TalesBlockTwoImageCycle = ({ images = [], border = true, isActive }) => {
    const rootRef = useRef(null);
    const captionRef = useRef([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [maxCaptionHeight, setMaxCaptionHeight] = useState(0);
    const [isHovering, setIsHovering] = useState(false);
    const [mode, setMode] = useState('isLoading'); // isLoading, isInteractive
    const [isInView, setIsInView] = useState(false);

    const isTouch = useDetectTouch();

    const intersection = useIntersection(rootRef, {
        root: null,
        rootMargin: '0px',
        threshold: 0.3,
    });

    useEffect(() => {
        if (intersection?.isIntersecting && isActive) {
            setIsInView(true);
            setMode('isInteractive');
        }

        if (!isActive) {
            setIsInView(false);
            setMode('isLoading');
        }
    }, [intersection, isActive]);

    const handleNextClick = () => {
        setIsHovering(false);
        setActiveIndex(activeIndex + 1 >= images.length ? 0 : activeIndex + 1);
    };

    useEffect(() => {
        const handleResize = () => {
            if (captionRef.current) {
                const heights = captionRef.current.map(
                    item => item.offsetHeight
                );
                const maxHeight = Math.max(...heights);
                setMaxCaptionHeight(maxHeight);
            }
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleMouseEnter = () => {
        setIsHovering(true);
    };

    const handleMouseLeave = () => {
        setIsHovering(false);
    };

    return (
        <section
            ref={rootRef}
            className={cx(styles.root, {
                [styles.border]: border,
                [styles.isInView]: isInView,
                [styles.isTouch]: isTouch,
                [styles.isHovering]: isHovering,
                [styles.isLoading]: mode === 'isLoading',
                [styles.isInteractive]: mode === 'isInteractive',
            })}
        >
            <div className={styles.inner}>
                <div
                    className={styles.media}
                    onClick={handleNextClick}
                    role="button"
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                >
                    {images?.map((image, index) => (
                        <div
                            key={index}
                            className={cx(styles.mediaItem, {
                                [styles.isActive]: index === activeIndex,
                            })}
                        >
                            <Img
                                className={styles.image}
                                src={image.url}
                                width={image?.width}
                                height={image?.height}
                                alt={image.description}
                                customSources={[
                                    {
                                        breakpoint: 768,
                                        src: image.url,
                                        imageWidth: 1920,
                                    },
                                    {
                                        src: image.url,
                                        imageWidth: 1280,
                                    },
                                ]}
                            />
                        </div>
                    ))}
                </div>
                <div
                    className={styles.caption}
                    style={{
                        height: maxCaptionHeight,
                    }}
                >
                    {images?.map((image, index) => (
                        <div
                            key={index}
                            className={cx(styles.captionItem, {
                                [styles.isActive]: index === activeIndex,
                            })}
                        >
                            <div
                                ref={el => (captionRef.current[index] = el)}
                                className={styles.captionItemInner}
                            >
                                {image.description && (
                                    <Text
                                        baseTheme="bodyXSmall"
                                        className={styles.caption}
                                    >
                                        <span
                                            dangerouslySetInnerHTML={{
                                                __html: image.description,
                                            }}
                                        />
                                    </Text>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TalesBlockTwoImageCycle;
